import { Outlet, useHref, useSearchParams, useNavigate } from 'react-router-dom';
import Navbar from '../sharedComponents/navbar/Navbar';
import Footer from '../sharedComponents/footer/Footer';
import { useEffect } from 'react';
import { captureAuthFromSearch } from '../../utils/authToken';
import "./mainLayout.css"
const MainLayout = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const url = useHref();

    const myParam = searchParams.get('token');

    useEffect(()=>{
        if(myParam){
            const currentPath = url || window.location.pathname;
            const isBookingsPage = currentPath.includes('/bookings');
            const hasPricingDraft = localStorage.getItem('sundorbonPricingDraftKeep');
            
            if (isBookingsPage || hasPricingDraft) {
                return;
            }

            captureAuthFromSearch(window.location.search);
            setSearchParams({});
            navigate('/', { replace: true });
        }
    },[myParam, navigate, setSearchParams, url])

    return (
        <div className={url.includes("bookings")?"MainLayoutCss pt-3  xl:pt-10":""}>
        <div className={url.includes("bookings")?"border-[#2c2c2c] rounded-[20px] lg:rounded-[35px] xl:rounded-[60px] overflow-hidden border-[7px]  lg:border-[15px] m-3 lg:m-5 xl:m-10 mt-0":""}>
            <Navbar />
            <Outlet />
            </div>
            <Footer />
        </div>
    );
};

export default MainLayout;